//AudioPage.js

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import './css/AudioPage.css';
import '../styles/burger-menu.css';
import AudioEditor from '../components/AudioEditor';
import AudioUpload from '../components/AudioUpload';
import NextButton from '../components/NextButton';
import RouteGuard from '../components/RouteGuard';
import { useAudio } from '../contexts/AudioContext';
import useScrollDirection from '../hooks/useScrollDirection';

function AudioPage() {
  const { audioData } = useAudio();
  const { scrollDirection, isAtTop } = useScrollDirection();

  const handleMenuToggle = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    window.dispatchEvent(new CustomEvent('toggleNavigationMenu'));
  };

  return (
    <RouteGuard requiresImage={true} redirectTo="/images">
      <div className="audio-page">
        <div className="audio-container">
          <div className="audio-content">
            <div className="audio-left-column">
              <div className="audio-upload-card">
                <div className="page-header-with-menu">
                  <button
                    className={`page-header-menu-button ${scrollDirection === 'down' && !isAtTop ? 'hide-on-scroll' : ''}`}
                    onClick={handleMenuToggle}
                    onTouchEnd={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleMenuToggle(e);
                    }}
                    type="button"
                    aria-label="Open menu"
                  >
                    <FontAwesomeIcon icon={faBars} />
                  </button>
                  <h2 className="page-title-mobile">Audio</h2>
                  <h2 className="page-title-desktop">Audio</h2>
                </div>
                <p className="page-description">
                  Upload your audio file and select the perfect section for your render.
                </p>
                <div className="audio-upload-section">
                  <AudioUpload />
                </div>
              </div>
            </div>
          </div>

          {audioData.file && (
            <div className="audio-editor-section">
              <AudioEditor />
            </div>
          )}

          <div className="page-navigation">
            <NextButton 
              nextPath="/preview" 
              disabled={!audioData.file}
              text="Preview Design"
            />
          </div>
        </div>
      </div>
    </RouteGuard>
  );
}

export default AudioPage;
